"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Favorites = void 0;
var _icons = require("@ori-ui/icons");
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useFavoritesLinkAndText = require("../../../hooks/useFavoritesLinkAndText");
var _constants = require("../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Favorites = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    favoritesLink,
    favoritesText
  } = (0, _useFavoritesLinkAndText.useFavoritesLinkAndText)();
  if (isAnonymousUser) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
    "data-testid": getTestId(_constants.FAVORITE_LIST_ITEM),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FavoritesRoot, {
      href: favoritesLink,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.HeartIconRoot, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Heart, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FavoritesTitle, {
        className: "favoritesTitle",
        children: favoritesText
      })]
    })
  });
};
exports.Favorites = Favorites;
